import tw from "tailwind-styled-components";

export const TitleContainer = tw.div`
flex
items-center
pt-9 
pl-12 
pr-12
`;
